import classes from './Footer.module.css';
import { useContext } from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';

// IMPORT OWN COMPONENTS
import Collapsible from '../UI/Collapsible';

// IMPORT HOOKS, CONTEXTS AND OTHER FUNCTIONS
import useGetMobile from '../../hooks/useWindowDimensions';
import AuthContext from '../../store/auth-context';

// IMPORT DATA
import { globals } from '../../data/global-vars.js';
import SingleText from '../UI/SingleText';
import { useBrandFind } from '../../hooks/useFinders';

// IMPORT ICONS
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';

function Footer() {
  const authCtx = useContext(AuthContext);
  const params = useParams();
  const page = params.page;
  const brand = params.brand;
  const brandObject = useBrandFind(brand);
  const brandHouse = useBrandFind(brand, 'house');
  let mobile = useGetMobile();
  const numberOfPagesToDisplay = Object.values(globals.PAGES).filter(
    (item) => !item.loginNeeded && item.showInFooter
  ).length;

  return (
    <div className={classes.wrapper} style={{}}>
      <div
        className={classes.container}
        style={{ paddingBottom: page === globals.PAGES.DETAIL.url && '80px' }}
      >
        <div style={{ margin: '20px' }}>
          {brandHouse.SOCIAL_MEDIA.INSTAGRAM && (
            <a
              href={brandHouse.SOCIAL_MEDIA.INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon className={classes.socialMediaIcon} />
            </a>
          )}
          {brandHouse.SOCIAL_MEDIA.FACEBOOK && (
            <a
              href={brandHouse.SOCIAL_MEDIA.FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon className={classes.socialMediaIcon} />
            </a>
          )}
          {brandHouse.SOCIAL_MEDIA.YOUTUBE && (
            <a
              href={brandHouse.SOCIAL_MEDIA.YOUTUBE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon className={classes.socialMediaIcon} />
            </a>
          )}
        </div>
        <div
          className={classes.footerNav}
          style={{
            flexDirection: mobile ? 'column' : 'row',
          }}
        >
          {Object.values(globals.PAGES).map((item, i) => {
            if (item.showInFooter) {
              if (item.loginNeeded !== true || authCtx.isLoggedIn) {
                return (
                  <div
                    key={i}
                    className={classes.navSection}
                    style={{
                      width: mobile
                        ? '100%'
                        : 100 / numberOfPagesToDisplay + '%',
                    }}
                  >
                    <Collapsible
                      label={
                        <span
                          className={classes.navSectionHeader}
                          style={{
                            cursor: mobile ? 'pointer' : 'default',
                          }}
                        >
                          {item.name}
                        </span>
                      }
                      deactivated={!mobile}
                    >
                      <div
                        className={classes.navSectionContent}
                        style={{
                          paddingLeft: mobile ? '5px' : 0,
                        }}
                      >
                        {item.subpages.map((p, i) => {
                          return (
                            <Link
                              to={
                                p.extern
                                  ? { pathname: 'https://electricbrands.de' }
                                  : `/${brand}${
                                      !p.otherPage ? '/' + item.url : ''
                                    }/${p.url}`
                              }
                              key={i}
                              style={{
                                color: 'inherit',
                                textAlign: 'left',
                                textDecoration: 'none',
                                fontSize: '14px',
                                lineHeight: 1.7,
                              }}
                              target={p.extern && '_blank'}
                            >
                              <span>{p.title}</span>
                            </Link>
                          );
                        })}
                      </div>
                    </Collapsible>
                  </div>
                );
              } else return null;
            } else return null;
          })}
        </div>
        <div className={classes.legallyHints}>
          <NavLink
            to={`/${brandObject.url}/${globals.PAGES.IMPRESSUM.url}/`}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
              fontSize: 'inherit',
            }}
          >
            {globals.PAGES.IMPRESSUM.name}
          </NavLink>
          <span> | </span>
          <NavLink
            to={`/${brandObject.url}/${globals.PAGES.KONTAKT.url}/`}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
            }}
          >
            {globals.PAGES.KONTAKT.name}
          </NavLink>
          <span> | </span>
          <NavLink
            to={`/${brandObject.url}/${globals.PAGES.DATENSCHUTZ.url}/`}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
            }}
          >
            {globals.PAGES.DATENSCHUTZ.name}
          </NavLink>
          <span> | </span>
          <NavLink
            to={`/login`}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            style={{
              textDecoration: 'none',
              color: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              lineHeight: 'inherit',
            }}
          >
            Interner Bereich
          </NavLink>
        </div>
        <div className="h-[1px] bg-[#707070] w-full" />
        <div className="text-xs mt-2">
          <SingleText id="63e53463486a292b5e4b4cd5" field="text" />
        </div>
      </div>
    </div>
  );
}

export default Footer;
